var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9875 14.2244L21.212 11.9999L18.9875 9.77539L18.139 10.6244L18.915 11.3999H15.5635V12.5999H18.915L18.139 13.3754L18.9875 14.2244Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 20.3999C7.3679 20.3999 3.5999 16.6319 3.5999 11.9999C3.5999 7.3679 7.3679 3.5999 11.9999 3.5999C14.8989 3.5999 17.5559 5.0654 19.1064 7.5204L20.1209 6.8794C18.3489 4.0744 15.3129 2.3999 11.9999 2.3999C6.7064 2.3999 2.3999 6.7064 2.3999 11.9999C2.3999 17.2934 6.7064 21.5999 11.9999 21.5999C15.3129 21.5999 18.3489 19.9254 20.1209 17.1204L19.1064 16.4794C17.5554 18.9344 14.8989 20.3999 11.9999 20.3999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 11.7115L8.625 13.9315L9.375 14.8685L12.6 12.2885V7.19995H11.4V11.7115Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/Check-out.96299963.svg";
export { ForwardRef as ReactComponent };